module.exports = __webpack_public_path__ + "static/media/200.7705ec55.jpg";